import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=7ce92498&scoped=true&"
import script from "./PrivacyDialog.vue?vue&type=script&lang=ts&"
export * from "./PrivacyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyDialog.vue?vue&type=style&index=0&id=7ce92498&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce92498",
  null
  
)

export default component.exports